import clsx from 'clsx';
import Image from 'next/image';
import Button from '../Button';
import HeroCountdownTimer from '../HeroCountdownTimer';

const HomeHeroTraits = () => {
  return (
    <div className='bg-gray-900 overflow-hidden relative'>
      <div className='absolute top-0 left-0 right-0 bottom-0 z-10 blur-sm'>
        <Image src='/twitter-share-image.png' alt='Trait Features' layout='fill' className='object-cover' />
      </div>

      <div className='absolute top-0 left-0 right-0 bottom-0 bg-black/70 z-20 w-full h-full'></div>

      <div className={clsx('grid lg:grid-cols-2 px-4 mx-auto lg:px-8 max-w-7xl relative z-30')}>
        <div className='pt-24 pb-12 md:pt-24 md:pb-24 relative'>
          {process.env.NEXT_PUBLIC_TRAIT_SHUFFLE_CURRENT_END_DATE && (
            <div className='mb-6'>
              <HeroCountdownTimer targetDate={process.env.NEXT_PUBLIC_TRAIT_SHUFFLE_CURRENT_END_DATE} title='Trait Pool Refreshes In' />
            </div>
          )}

          <h1 className='text-5xl font-extrabold text-neutral-200 md:text-8xl'>
            Fourth Litter <span className='text-primary-500'>Trait Utilities</span>
          </h1>
          <h2 className='text-base text-neutral-400 md:text-3xl mt-4 max-w-lg'>
            Shuffle random traits or swap traits between your Fourth Litter Shitty Kitties using Shitty Treats and $ALGO.
          </h2>
          <div className='mt-4 max-w-[200px] md:max-w-[400px]'>
            <Image src='/accents/underline.png' alt='accent underline' width={722} height={121} />
          </div>

          <div className='flex flex-col'>
            <div className='mt-8 flex md:flex-row flex-col justify-center md:justify-start md:items-center gap-6 w-full max-w-[400px]'>
              <Button href={'/trait-shuffle'} className='group flex items-center gap-3 justify-center' link theme='primary'>
                <span className='font-medium text-xl'>Trait Shuffle</span>
              </Button>
              <Button href={'/trait-swapper'} className='group flex items-center gap-3 justify-center' link theme='outline-white'>
                <span className='font-medium text-xl'>Trait Swapper</span>
              </Button>
            </div>
          </div>
        </div>

        <div className='lg:absolute md:hidden lg:block right-0 top-0 bottom-0'></div>
      </div>
    </div>
  );
};

export default HomeHeroTraits;
